import { Box } from '@mui/material';
import React from 'react';
import { themeColors } from '../../JuvareTheme';
/**
 * Renders the concentric background visual for a card icon, adapting layout based on size.
 *
 * @param {object} root0 - Component props.
 * @param {boolean} [root0.large] - Whether to render a larger offset-aligned background.
 * @returns {JSX.Element} The rendered background layers for a card icon.
 */
export const CardIconBackground = ({ large }) => {
    const sx = { flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' };
    return (React.createElement(Box, { sx: Object.assign({ position: 'absolute', top: 'calc(50% - 52px)', left: large ? -12 : 'calc(50% - 52px)', backgroundColor: themeColors.overlay.primaryAlpha, width: 104, height: 104, borderRadius: 52 }, sx) },
        React.createElement(Box, { sx: Object.assign({ backgroundColor: themeColors.overlay.primaryAlpha, width: 72, height: 72, borderRadius: 36 }, sx) },
            React.createElement(Box, { sx: Object.assign({ backgroundColor: themeColors.decorative.white, width: 40, height: 40, borderRadius: 20 }, sx) }))));
};
